import { WallIcon } from './WallIcon';

/**
 * author: Austin Andrews
 * id 5DAB0112-3768-4ADC-8796-A88B4473FE56
 * name wall
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall.svg
 * tags
 */
export const BricksIcon = WallIcon;
export default BricksIcon